import type { Agency } from '@saaga/shared/interfaces/agencies.interface'
import { FileTextIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Separator } from '@/components/ui/separator'

import { formatUsageCount } from './agency.util'
import { PriceRangeIndicator } from './price-range-indicator.atom'
import { StarRating } from './star-rating.atom'

interface AgencyDetailStatsProps {
  rating: number
  reviewCount: number
  usageCount: number
  priceRange: Agency['priceRange']
}

export const AgencyDetailStats = ({
  rating,
  reviewCount,
  usageCount,
  priceRange,
}: AgencyDetailStatsProps): ReactNode => (
  <div className="agency-detail-stats flex flex-wrap items-center gap-4 md:gap-6">
    <div className="flex items-center gap-2">
      <StarRating rating={rating} size="md" showValue />
      {reviewCount > 0 && (
        <span className="text-sm text-muted-foreground">({reviewCount} reviews)</span>
      )}
    </div>
    <Separator orientation="vertical" className="h-5 hidden md:block" />
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <FileTextIcon className="size-4" />
      <span>{formatUsageCount(usageCount)} reports generated</span>
    </div>
    <Separator orientation="vertical" className="h-5 hidden md:block" />
    <div className="flex items-center gap-2">
      <span className="text-sm text-muted-foreground">Price:</span>
      <PriceRangeIndicator level={priceRange} size="md" />
    </div>
  </div>
)

AgencyDetailStats.displayName = 'AgencyDetailStats'
